import { connect } from 'react-redux';
import Detecting from '../components/ThetaDetecting';
import { fetchList } from '../actions/ThetaDetecting';
import { postData } from '../actions/ThetaBindList'


const mapStateToProps = (state, ownProps) => ({
    categoryId: ownProps.categoryId,
    category: state.Detecting.category,
    bind: state.Detecting.bind,
    serialnumber: state.Detecting.serialnumber,
    devicename: state.Detecting.devicename,
    error: state.Detecting.error,
    ranking: state.BindList.ranking,
    checkedB: state.BindList.checkedB,
});

const mapDispatchToProps = dispatch => ({
    onMount(categoryId) {
        dispatch(fetchList(categoryId));
    },
    onUpdate(serialnumber, devicename) {
        dispatch(fetchList(serialnumber, devicename));
    },
    onPostData(ranking, item,checked) {
        dispatch(postData(ranking, item, checked));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Detecting);



// WEBPACK FOOTER //
// ./src/containers/ThetaDetecting.js